import {endpoints} from './endpoints'
import request from '../../request'

export function chatWithTools(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.chatWithTools,
			method: 'post',
			data,
			timeout: 100000
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}